import { Result } from "antd";
import { useEffect } from "react";
import PageLayout from "../../components/PageLayout";
import { setPageTitle } from "../../utils";
import "./styles.less";

const ProjectComing = () => {
  useEffect(() => {
    setPageTitle("Pas de projet");
  }, []); // eslint-disable-line

  return (
    <PageLayout>
      <Result status={404} />
    </PageLayout>
  );
};

export default ProjectComing;
